import React from "react";
import HomeBanner from '../components/homeBanner/homeBanner';
import KtempleNav from '../components/ktempleNav/ktempleNav';
import Footer from '../components/Footer/Footer';
import VisitingTemple from '../components/VisitingTemple/VisitingTemple';
import KrishnaDonateTemple from "../components/krishnadonate/krishnadonate";
import DocumentMeta from 'react-document-meta';
import UpcomingEvents from "../components/upcomingevents/upcomingevents";

function KrishnaTempleDonate() {
const meta = {
    title: "Donate - Radha Madhav Krishna Temple Milwaukee",
    description: "Support the Radha Madhav Krishna Temple in Milwaukee. Your donations help us maintain our temple and serve the community.",
    keywords: "Donate, Radha Madhav Krishna Temple, Milwaukee, support, community"
  };
  return (
    <div>
      <DocumentMeta {...meta} />
      <KtempleNav />
      <UpcomingEvents />
      <HomeBanner />
      <KrishnaDonateTemple />
      <VisitingTemple />
      <Footer />
    </div>
  )
}

export default KrishnaTempleDonate